import { render, staticRenderFns } from "./WarehouseInventory.vue?vue&type=template&id=61d805fe&scoped=true&"
import script from "./WarehouseInventory.vue?vue&type=script&lang=js&"
export * from "./WarehouseInventory.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseInventory.vue?vue&type=style&index=0&id=61d805fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d805fe",
  null
  
)

export default component.exports